import React from 'react';

const TitleSlide = ({ slide, slideKey }) => {
    return (
        <div key={slideKey} className="h-full flex flex-col items-center justify-center p-12 text-center relative">
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <div className="relative w-64 h-64">
                    {[0, 1, 2].map((i) => (
                        <div key={i} className="absolute top-1/2 left-1/2 w-2 h-2 bg-cyan-400 rounded-full"
                            style={{
                                animation: `orbit ${8 + i * 2}s linear infinite`,
                                animationDelay: `${i * 0.5}s`,
                                opacity: 0.3
                            }}
                        />
                    ))}
                </div>
            </div>
            {/* Le dégradé de fond doit couvrir la slide ENTIÈRE, bandeau
                compris. Le conteneur de template est en `pt-20` pour réserver
                la place du logo et du chapitre : peint dans `inset-0`, le fond
                démarrait sous le bandeau et laissait une bande plus sombre en
                haut — que l'`animate-pulse` faisait battre, donc bien visible
                au vidéoprojecteur. `-top-20` annule exactement ce padding (même
                valeur en rem, donc le compte reste juste malgré le `font-size`
                racine mis à l'échelle de la largeur par la page de conférence),
                et le `overflow-hidden` du cadre de slide rattrape le débord. */}
            <div className="absolute inset-x-0 -top-20 bottom-0 opacity-10">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500 via-purple-500 to-cyan-500 animate-pulse" />
            </div>
            <div className="relative z-10">
                <h1 className="text-8xl font-black mb-6 bg-gradient-to-r from-blue-400 via-purple-400 to-cyan-400 bg-clip-text text-transparent leading-tight animate-fade-in-up">
                    {slide.title}
                </h1>
                <p className="text-5xl text-blue-200/80 mb-12 font-light animate-fade-in-up stagger-1">
                    {slide.subtitle}
                </p>
                <div className="mt-16 space-y-2 text-blue-300/60 animate-fade-in-up stagger-2">
                    <p className="text-3xl text-blue-300">{slide.author}</p>
                    <p className="text-2xl text-blue-300">{slide.date}</p>
                </div>
            </div>
        </div>
    );
};

export default TitleSlide;
